module.exports = __webpack_public_path__ + "static/media/BSPLogoTranSmall.5cb773f5.png";